<template>
  <div class="modal-card" style="width: auto">
    <header class="modal-card-head">
      <p class="modal-card-title">Acerca de esta aplicación</p>
    </header>

    <section class="modal-card-body">
      <div v-html="content" v-if="contentReady"></div>
    </section>

    <footer class="modal-card-foot">
      <div>
        <b-button type="is-primary" @click="$parent.close()">
          Cerrar
        </b-button>
      </div>
    </footer>
  </div>
</template>

<script>
import showdown from 'showdown'
import showdownBulma from '@/utils/showdown-bulma'
import aboutMarkdown from '@/assets/about.md'

export default {
  name: 'AboutModal',
  data() {
    return {
      content: null
    }
  },
  computed: {
    contentReady() {
      return this.content !== null
    }
  },
  mounted() {
    // let loading = this.$buefy.loading.open({
    //   container: this.$refs.root.$el
    // })
    //
    const converter = new showdown.Converter({
      extensions: [...showdownBulma]
    })
    this.content = converter.makeHtml(aboutMarkdown)
    //
    // loading.close()
  }
}
</script>
